import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-timpicker',
  templateUrl: './custom-timpicker.component.html',
  styleUrls: ['./custom-timpicker.component.scss'],
})
export class CustomTimpickerComponent {
  selectedHour: number = 0;
  selectedMinute: number = 0;

  @Output() timeSelected = new EventEmitter<string>();
  constructor() {}

  ngOnInit(): void {}

  validateHour() {
    if (this.selectedHour > 23) {
      this.selectedHour = 23;
    } else if (this.selectedHour < 0) {
      this.selectedHour = 0;
    }
  }

  validateMinute() {
    if (this.selectedMinute > 59) {
      this.selectedMinute = 59;
    } else if (this.selectedMinute < 0) {
      this.selectedMinute = 0;
    }
  }

  onTimeSelect() {
    const timeString = `${this.selectedHour
      .toString()
      .padStart(2, '0')}:${this.selectedMinute.toString().padStart(2, '0')}`;
    this.timeSelected.emit(timeString); // Emit selected time
  }
}
